import { RedirectedRoutes } from './redirected.routes';
import { getApplicationSetRoutes } from './application-set.routes';
import { PlantOperatingRoutes } from './plant-operating.routes';
import { AdministrationRoutes } from './administration.routes';
import { SubnaviDropDownService } from '@navigation';
import { LoginScreen } from '@login';
import { WinFormsContentScreen } from '@winforms';
import { __asyncI18n } from '@localisation';
import { DashboardNaviExtension, UserDashboardComponent } from '@dashboards';
import { DashboardEditorComponent, SystemDashboarEditor } from '@dashboards-editor';
import { RegistrationComponent, VerificationCodeComponent, ExtLoginRegistrationInfoComponent } from '@registration';
import { ResetPasswordComponent, SetPasswordComponent, ChangePasswordComponent } from '@change-password';
import { DummySiteComponent } from '@site-info';
import { FormControlTest } from '@forms';
import { ManageProfileComponent } from '@user';
import { ReleaseNotesPopupOpenerComponent } from '@release-notes';
import { PlantStatusMapComponent, SystemStatusMapComponent } from '@maps';
import { CreateNewTenantComponent } from '@tenant';
import { InternalReleaseNotesComponent } from '@internal-release-notes';
import { CookieInfoComponent, CookieInfoOutsideComponent } from '@cookie';
import { PlantApplicationSetsComponent, SystemApplicationSetsComponent, TenantApplicationSetsComponent } from '@application-sets';
import { OperatingAccessService, PlantAdministrationListComponent, PlantOperatingPageComponent } from '@plants';
import { RoutePrivilegeNames } from './routeprivilegenames';
import { CachedChildRedirectComponent } from '@routing';

import { SystemOperatingRoutes } from './system-operating.routes';
import { SystemOperatingPageComponent } from '@systems';

import { ApiDocumentationComponent, ApiComingSoonComponent, ApiComponent, ApiFaqComponent, AppContainerDocumentationComponent } from '@api-documentation';
import { ScriptingEditorComponent } from 'modules/scripting-editor-module/scripting-editor.component';
import { BenchmarkDashboardComponent } from '@benchmark-dashboard';
import { AppContainerEditorComponent, SandboxPolicy } from '@app-container';
import { ImportAlarmIdsComponent } from '@alarm';
import { AlarmDashboardComponent } from '@alarm-dashboard';
import { NodeRedComponent } from 'modules/node-red-module';
import { FramePageComponent } from 'modules/proto-pages-module/frame-page.component';
import { StandaloneTrendViewerComponent } from '@trendviewer';
import { AppContainerPageComponent } from 'modules/app-container-module/app-container.page.component';


const cookieNoticeTile = __asyncI18n('Cookie Notice', 'subnavi.cookie-info');

export const MainRoutes: any = [
    ...RedirectedRoutes,
    {
        path: 'InternalReleaseNotes',
        pathMatch: 'full',
        component: InternalReleaseNotesComponent,
        data: {
            title: 'Internal Release Notes',
            testId: 'mainnavigation.link.internalreleasenotes',
            dontShowInMainNavigation: true
        }
    },
    {
        path: 'ReleaseNotes',
        pathMatch: 'full',
        data: {
            testId: 'mainnavigation.link.releasenotes',
            dontShowInMainNavigation: true,
            stopAutoLoggout: true
        },
        children: [
            {
                path: '',
                outlet: 'loggedout',
                component: ReleaseNotesPopupOpenerComponent,
                data: {
                    title: __asyncI18n('ReleaseNotes', 'subnavi.releasenotes'),
                    stopAutoLoggout: true
                }
            }
        ]
    },
    {
        path: 'Login',
        pathMatch: 'full',
        data: {
            title: __asyncI18n('Log In', 'mainnavi.login'),
            dontShowInMainNavigation: true
        },
        children: [
            {
                path: '',
                outlet: 'loggedout',
                component: LoginScreen,
                data: {
                    title: __asyncI18n('Log In', 'mainnavi.login')
                }
            }
        ]
    },
    {
        path: 'Registration',
        pathMatch: 'full',
        data: {
            title: __asyncI18n('Registration', 'mainnavi.registration'),
            dontShowInMainNavigation: true
        },
        children: [
            {
                path: '',
                outlet: 'loggedout',
                component: RegistrationComponent,
                data: {
                    title: __asyncI18n('Registration', 'mainnavi.registration')
                }
            }
        ]
    },
    {
        path: 'ExtLoginRegistrationInfo',
        pathMatch: 'full',
        data: {
            title: __asyncI18n('Unknown External Login', 'mainnavi.unknownextlogin'),
            dontShowInMainNavigation: true
        },
        children: [
            {
                path: '',
                outlet: 'loggedout',
                component: ExtLoginRegistrationInfoComponent,
                data: {
                    title: __asyncI18n('Unknown External Log in', 'mainnavi.unknownextlogin')
                }
            }
        ]
    },
    {
        path: 'ResetPassword',
        pathMatch: 'full',
        data: {
            title: __asyncI18n('Reset password', 'mainnavi.resetpassword'),
            dontShowInMainNavigation: true
        },
        children: [
            {
                path: '',
                outlet: 'loggedout',
                component: ResetPasswordComponent,
                data: {
                    title: __asyncI18n('Reset password', 'mainnavi.resetpassword')
                }
            }
        ]
    },
    {
        path: 'ResetPasswordExt',
        pathMatch: 'full',
        data: {
            title: __asyncI18n('Reset password', 'mainnavi.resetpassword'),
            dontShowInMainNavigation: true
        },
        children: [
            {
                path: '',
                outlet: 'loggedout',
                component: ResetPasswordComponent,
                data: {
                    title: __asyncI18n('Reset password', 'mainnavi.resetpassword')
                }
            }
        ]
    },
    {
        path: 'VerificationCode',
        pathMatch: 'full',
        data: {
            title: __asyncI18n('Confirm code', 'mainnavi.confirmcode'),
            dontShowInMainNavigation: true
        },
        children: [
            {
                path: '',
                outlet: 'loggedout',
                component: VerificationCodeComponent,
                data: {
                    title: __asyncI18n('Confirm code', 'mainnavi.confirmcode')
                }
            }
        ]
    },
    {
        path: 'SetPassword/:id',
        pathMatch: 'full',
        data: {
            title: __asyncI18n('Set password', 'mainnavi.setpassword'),
            dontShowInMainNavigation: true
        },
        children: [
            {
                path: '',
                outlet: 'loggedout',
                component: SetPasswordComponent,
                data: {
                    title: __asyncI18n('Set password', 'mainnavi.setpassword')
                }
            }
        ]
    },
    {
        path: 'ChangePassword',
        pathMatch: 'full',
        data: {
            title: __asyncI18n('Change password', 'mainnavi.changepassword'),
            stopAutoLoggout: true,
            dontShowInMainNavigation: true
        },
        children: [
            {
                path: '',
                outlet: 'loggedout',
                component: ChangePasswordComponent,
                data: {
                    title: __asyncI18n('Change password', 'mainnavi.changepassword'),
                    stopAutoLoggout: true,
                    dontShowInMainNavigation: true
                }
            }
        ]
    },
    {
        path: 'Account',
        data: {
            title: __asyncI18n('Account', 'mainnavi.account'),
            redirectTo: 'Home/StatusMap/Plants',
            dontShowInMainNavigation: true,
            hideMainNavigationIndicator: true
        },
        children: [
            {
                path: 'Profile',
                component: ManageProfileComponent,
                data: {
                    title: __asyncI18n('Profil', 'subnavi.profil'),
                    dontShowFavourites: true,
                    dontShowInBreadCrumb: true,
                    dontShowInSubNavigation: true,
                    hideMainNavigationIndicator: true
                }
            },
            {
                path: 'ChangePassword',
                component: WinFormsContentScreen,
                data: {
                    title: __asyncI18n('Change password', 'subnavi.changepassword'),
                    contentRoute: '/Account/ChangePassword',
                    dontShowFavourites: true,
                    dontShowInBreadCrumb: true,
                    dontShowInSubNavigation: true,
                    hideMainNavigationIndicator: true
                }
            },
            {
                path: 'ConfirmDelete',
                component: WinFormsContentScreen,
                data: {
                    title: __asyncI18n('Confirm delete', 'subnavi.confirmdelete'),
                    contentRoute: '/Account/ConfirmDelete',
                    dontShowFavourites: true,
                    dontShowInBreadCrumb: true,
                    dontShowInSubNavigation: true,
                    hideMainNavigationIndicator: true
                }
            }
        ]
    },
    {
        path: 'ActivatePlant',
        pathMatch: 'full',
        component: WinFormsContentScreen,
        data: {
            title: __asyncI18n('Activate Plant', 'mainnavi.activate.plant'),
            contentRoute: '/Site/SiteAdministration/ActivatingSite',
            dontShowInMainNavigation: true,
            dontShowInSubNavigation: true
        }
    },
    {
        path: 'CreateNewTenant',
        pathMatch: 'full',
        component: CreateNewTenantComponent,
        data: {
            title: __asyncI18n('Create New Tenant', 'mainnavi.create.new.tenant'),
            dontShowInMainNavigation: true,
            dontShowInSubNavigation: true
        }
    },
    {
        path: '',
        redirectTo: 'Home',
        pathMatch: 'full'
    },
    {
        path: 'Home',
        data: {
            title: __asyncI18n('Dashboard', 'mainnavi.dashboard'),
            redirectTo: 'Home/StatusMap/Plants',
            testId: 'mainnavigation.link.dashboard',
            iconClass:'simpl-icon-home'
        },
        children: [
            //Dashboard
            {
                path: 'StatusMap',
                data: {
                    title: __asyncI18n('Map', 'subnavi.map'),
                    dontShowFavourites: true,
                    testId: 'sidenavigation.link.statusmap',
                    redirectTo: 'Home/StatusMap/Plants'
                },
                children: [
                    {
                        path: '',
                        redirectTo: 'Home/StatusMap/Plants',
                        pathMatch: 'full',
                        data: {
                            title: __asyncI18n('Map', 'subnavi.map'),
                            dontShowFavourites: true,
                            testId: 'sidenavigation.link.statusmap',
                            redirectTo: 'Home/StatusMap/Plants'
                        }
                    },
                    {
                        path: 'Plants',
                        component: PlantStatusMapComponent,
                        data: {
                            title: __asyncI18n('Map', 'subnavi.map'),
                            dontShowFavourites: true,
                            testId: 'sidenavigation.link.statusmap.plants',
                            showSubNaviLevel: 1,
                            dontShowInBreadCrumb: true
                        }
                    },
                    {
                        path: 'Systems',
                        component: SystemStatusMapComponent,
                        data: {
                            title: __asyncI18n('Map', 'subnavi.map'),
                            dontShowFavourites: true,
                            testId: 'sidenavigation.link.statusmap.systems',
                            showSubNaviLevel: 1,
                            dontShowInBreadCrumb: true,
                            privileges: [
                                RoutePrivilegeNames.Systems
                            ]
                        }
                    },
                ]
            },
            {
                path: 'HomePage',
                component: DummySiteComponent,
                data: {
                    title: __asyncI18n('Overview', 'subnavi.overview'),
                    contentRoute: '/HomePage/?_=1491831269759',
                    dontShowFavourites: true,
                    dynamicSiblings: DashboardNaviExtension,
                    redirectTo: '*firstPathStartsWith|Dashboards',
                    dontShowInSubNavigation: true,
                    testId: 'sidenavigation.link.overview',
                    privileges: [
                        //RoutePrivilegeNames.AppsDashboardManage,
                        RoutePrivilegeNames.AppsDashboard
                    ]
                }
            },
            {
                path: 'ControlTest',
                component: FormControlTest,
                data: {
                    title: __asyncI18n('ControlTest', 'subnavi.control.test'),
                    showSubNaviLevel: 1,
                    dontShowInSubNavigation: true
                }
            },
            {
                path: 'Dashboards',
                data: {
                    title: __asyncI18n('Dashboards', 'subnavi.dashboards'),
                    dontShowFavourites: true,
                    showSubNaviLevel: 1,
                    dontShowInBreadCrumb: true,
                    dontShowInSubNavigation: true,
                    redirectTo: '/Home/Dashboards/*firstChild',
                    privileges: [
                        //RoutePrivilegeNames.AppsDashboardManage,
                        RoutePrivilegeNames.AppsDashboard
                    ]
                },
                children: [
                    {
                        path: ':dashboardid',
                        data: {
                            title: ':dashboardid | dashboardIdToName',
                            contentRoute: '/HomePage/:dashboardid',
                            showSubNaviLevel: 1,
                            testId: 'sidenavigation.link.overview',
                            dontShowFavourites: true
                        },
                        children: [
                            {
                                path: '',
                                component: UserDashboardComponent,
                                data: {
                                    title: ':dashboardid | dashboardIdToName',
                                    contentRoute: '/HomePage/:dashboardid',
                                    showSubNaviLevel: 1,
                                    dontShowFavourites: true
                                }
                            },
                            {
                                path: 'Trend',
                                data: {
                                    title: 'Trend',
                                    dontShowInSubNavigation: true,
                                    showSubNaviLevel: 1,
                                    dontShowInBreadCrumb: true
                                },
                                children: [
                                    {
                                        path: ':tileid',
                                        loadChildren: () => import('modules/viewnodes-module/index').then(m => m.ViewNodesModule),
                                        data: {
                                            title: ':tileid | tileIdToName',
                                            dontShowInSubNavigation: true,
                                            showSubNaviLevel: 1,
                                            lazyRedirectTo: 'Home/Dashboards/:dashboardid/Trend/:tileid/View',
                                            selectPathWhen: {
                                                path: '/Home/HomePage',
                                                when: {
                                                    dashboardid: '00000000-0000-0000-0000-000000000000'
                                                }
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },

    //Operating
    {
        path: 'Operating',
        data: {
            title: __asyncI18n('Operating', 'mainnavi.operating'),
            // contentRoute: '/Site/Site/List?_=1491835647595',
            testId: 'mainnavigation.link.operating',
            privileges: [
                RoutePrivilegeNames.PlantOperating
            ],
            favouritesType: 'sites',
            favouritesTitle: '[PageName]',
            iconClass:'simpl-icon-plant'
        },
        children: [
            {
                path: '',
                component: CachedChildRedirectComponent,
                data: {
                    title: __asyncI18n('Operating', 'mainnavi.operating'),
                }
            },
            {
                path: 'Systems',
                canActivate: [OperatingAccessService],
                data: {
                    title: __asyncI18n('Systems', 'subnavi.operating.systems'),
                    contentRoute: '/Site/Site/List?_=1491835647595',
                    testId: 'mainnavigation.link.operating',
                    dontShowInSubNavigation: true,
                    dontShowFavourites: true,
                    dontShowBreadCrumb: true,
                    privileges: [
                        RoutePrivilegeNames.Systems
                    ],
                    favouritesType: 'sites',
                    favouritesTitle: '[PageName]'
                },
                children: [
                    {
                        path: '',
                        component: SystemOperatingPageComponent,
                        canActivate: [OperatingAccessService],
                        data: {
                            title: __asyncI18n('Systems', 'subnavi.operating.systems'),
                            contentRoute: '/Site/Site/List',
                            dontShowInSubNavigation: true,
                            dontShowFavourites: true,
                            dontShowBreadCrumb: true,
                            privileges: [
                                RoutePrivilegeNames.Systems
                            ],
                            favouritesType: 'sites',
                            favouritesTitle: '[PageName]'
                        }
                    },
                    ...SystemOperatingRoutes
                ]
            },
            {
                path: 'Plants',
                data: {
                    title: __asyncI18n('Plants', 'subnavi.operating.plants'),
                    testId: 'mainnavigation.link.operating',
                    favouritesType: 'sites',
                    dontShowInSubNavigation: true,
                    dontShowBreadCrumb: true,
                    visible: true,
                    favouritesTitle: '[PageName]',
                },
                children: [
                    {
                        path: '',
                        component: PlantOperatingPageComponent,
                        data: {
                            title: __asyncI18n('Plants', 'subnavi.operating.plants'),
                            testId: 'sidenavigation.link.alarms',
                            dontShowInSubNavigation: true,
                            dontShowBreadCrumb: true,
                            favouritesType: 'sites',
                            favouritesTitle: '[PageName]'
                        }
                    },
                    ...PlantOperatingRoutes
                ]
            },
            {
                path: '**',
                component: DummySiteComponent,
                data: {
                    redirectTo: '/Operating/Plant/**'
                }
            }
        ]

        // children : [
        //     ...OperatingRoutes
        // ]
    },

    //Application sets
    {
        path: 'ApplicationSet',
        data: {
            title: __asyncI18n('Application set', 'mainnavi.applicationset'),

            testId: 'mainnavigation.link.applicationset',
            privileges: [
                RoutePrivilegeNames.ApplicationSetsManage,
                RoutePrivilegeNames.ApplicationSetsAccess
            ],
            favouritesType: 'applicationsets',
            favouritesRouteTitle: '[MainPageName]',
            iconClass:'simpl-icon-maintenance'
        },
        children: [
            {
                path: '',
                component: CachedChildRedirectComponent,
                data: {
                    title: __asyncI18n('Application set', 'mainnavi.applicationset'),
                    testId: 'mainnavigation.link.applicationset',
                    privileges: [
                        RoutePrivilegeNames.ApplicationSetsManage,
                        RoutePrivilegeNames.ApplicationSetsAccess
                    ]
                }
            },
            {
                path: 'System',
                data: {
                    title: __asyncI18n('System Application set', 'subnavi.application.system-application-set'),
                    dontShowInSubNavigation: true,
                    dontShowFavourites: true,
                    favouritesType: 'applicationsets',
                    testId: 'sidenavigation.link.system-applicationset',
                    visible: true,
                    dontShowBreadCrumb: true,
                    privileges: [
                        RoutePrivilegeNames.SystemApplicationSets
                    ]
                },
                children: [
                    {
                        path: '',
                        component: SystemApplicationSetsComponent,
                        data: {
                            title: __asyncI18n('System Application set', 'subnavi.application.system-application-set'),
                            dontShowInSubNavigation: true,
                            testId: 'sidenavigation.link.system-applicationset',
                            favouritesType: 'applicationsets',
                            visible: true,
                            dontShowBreadCrumb: true,
                            privileges: [
                                RoutePrivilegeNames.SystemApplicationSets
                            ]
                        }
                    },
                    ...getApplicationSetRoutes('System')
                ]
            },
            {
                path: 'Plant',
                data: {
                    title: __asyncI18n('Plant Application set', 'subnavi.application.plant-application-set'),
                    testId: 'sidenavigation.link.plant-applicationset',
                    favouritesType: 'applicationsets',
                    dontShowInSubNavigation: true,
                    visible: true,
                    dontShowBreadCrumb: true,
                },
                children: [
                    {
                        path: '',
                        component: PlantApplicationSetsComponent,
                        data: {
                            title: __asyncI18n('Plant Application set', 'subnavi.application.plant-application-set'),
                            dontShowInSubNavigation: true,
                            testId: 'sidenavigation.link.plant-applicationset',
                            favouritesType: 'applicationsets',
                            visible: true,
                            dontShowBreadCrumb: true
                        }
                    },
                    ...getApplicationSetRoutes('Plant')
                ]
            },
            {
                path: 'Tenant',
                data: {
                    title: __asyncI18n('Tenant Application set', 'subnavi.application.tenant-application-set'),
                    dontShowInSubNavigation: true,
                    testId: 'sidenavigation.link.tenant-applicationset',
                    favouritesType: 'applicationsets',
                    visible: true,
                    dontShowBreadCrumb: true
                },
                children: [
                    {
                        path: '',
                        component: TenantApplicationSetsComponent,
                        data: {
                            title: __asyncI18n('Tenant Application set', 'subnavi.application.tenant-application-set'),
                            dontShowInSubNavigation: true,
                            testId: 'sidenavigation.link.tenant-applicationset',
                            favouritesType: 'applicationsets',
                            visible: true,
                            dontShowBreadCrumb: true
                        }
                    },
                    ...getApplicationSetRoutes('Tenant')
                ]
            }
        ]
    },

    //Administration
    {
        path: 'Administration',
        data: {
            title: __asyncI18n('Administration', 'mainnavi.administration'),
            redirectTo: [
                'Administration/*firstChild'
            ],
            //breadCrumbDropDown : SubnaviDropDownService,
            testId: 'mainnavigation.link.administration',
            favouritesRouteColor: 'natural-red',
            favouritesRouteTitle: '[MainPageName]',
            privileges: [
                RoutePrivilegeNames.ProductDefinition,
                RoutePrivilegeNames.SystemNotifications,
                RoutePrivilegeNames.BillingAdmin,
                RoutePrivilegeNames.DigitalWallet,
                RoutePrivilegeNames.PlantsUnassigned,
                RoutePrivilegeNames.TenantUsers,
                RoutePrivilegeNames.TenantManage,
                RoutePrivilegeNames.PlantRolesManage,
                RoutePrivilegeNames.PlantPreRegister,
                RoutePrivilegeNames.ManagePlantUsers,
                RoutePrivilegeNames.ManagePlantSettings,
                RoutePrivilegeNames.NotificationAccess,
                RoutePrivilegeNames.PlantAdministration,
                RoutePrivilegeNames.PlantAlarmNotification,
                RoutePrivilegeNames.PlantLicenseAccess,
                RoutePrivilegeNames.PlantLicenseManage,
                RoutePrivilegeNames.ManageSystemUsers,
                RoutePrivilegeNames.ManageSystemSettings,
                RoutePrivilegeNames.SystemNotificationAccess,
                RoutePrivilegeNames.SystemAlarmNotification,
                RoutePrivilegeNames.Systems
            ],
            iconClass:'simpl-icon-manager'
        },
        children: [
            {
                path: '',
                component: DummySiteComponent, //dummy site is needed to avoid canActivae Problems
                data: {
                    title: __asyncI18n('Administration', 'mainnavi.administration'),
                    redirectTo: [
                        'Administration/*firstChild'
                    ],
                    //breadCrumbDropDown : SubnaviDropDownService,
                    testId: 'mainnavigation.link.administration',
                    favouritesType: 'siteadministration',
                    privileges: [
                        RoutePrivilegeNames.ProductDefinition,
                        RoutePrivilegeNames.SystemNotifications,
                        RoutePrivilegeNames.BillingAdmin,
                        RoutePrivilegeNames.DigitalWallet,
                        RoutePrivilegeNames.PlantsUnassigned,
                        RoutePrivilegeNames.TenantUsers,
                        RoutePrivilegeNames.TenantManage,
                        RoutePrivilegeNames.PlantRolesManage,
                        RoutePrivilegeNames.PlantPreRegister,
                        RoutePrivilegeNames.ManagePlantUsers,
                        RoutePrivilegeNames.ManagePlantSettings,
                        RoutePrivilegeNames.NotificationAccess,
                        RoutePrivilegeNames.PlantAdministration,
                        RoutePrivilegeNames.PlantLicenseAccess,
                        RoutePrivilegeNames.PlantLicenseManage,
                        RoutePrivilegeNames.ManageSystemUsers,
                        RoutePrivilegeNames.ManageSystemSettings,
                        RoutePrivilegeNames.SystemNotificationAccess,
                        RoutePrivilegeNames.SystemAlarmNotification
                    ]
                }
            },
            ...AdministrationRoutes
        ]
    },

    //Apps
    {
        path: 'Apps',
        data: {
            title: __asyncI18n('Apps', 'subnavi.apps'),
            redirectTo: [
                'Apps/*firstChild',
                'Apps/CloudGraphicConfigurator',
                'Apps/SystemDashboardEditor',
                'Apps/BenchmarkDashboard',
                'Apps/AlarmDashboard',
                'Apps/RuleEngine',
                'Apps/HorizonReports',
                'Apps/HealthCheck',
            ],
            breadCrumbDropDown: SubnaviDropDownService,
            testId: 'mainnavigation.link.apps',
            privileges: [
                RoutePrivilegeNames.AppsWebGraphic,
                RoutePrivilegeNames.AppsDashboardManage,
                RoutePrivilegeNames.AppsAlarmDashboard,
                RoutePrivilegeNames.AppsRuleEngine,
                RoutePrivilegeNames.AppsHealthCheck,
                RoutePrivilegeNames.AppsApiPortal,
                RoutePrivilegeNames.ScriptingRuntime,
                [
                    RoutePrivilegeNames.AppsSystemDashboardManage,
                    RoutePrivilegeNames.Systems
                ],
                [
                    RoutePrivilegeNames.AppsSystemDashboardManage,
                    RoutePrivilegeNames.SystemApplicationSets
                ],
                RoutePrivilegeNames.AppsBenchmarkDashboardUI,
                RoutePrivilegeNames.AppsAlarmImportIds,
                RoutePrivilegeNames.AppsContainerEditorUI,
                RoutePrivilegeNames.AppsTrendViewerUI
            ],
            iconClass:'simpl-icon-apps'
        },
        children: [
            {
                path: 'TrendViewer',
                component: StandaloneTrendViewerComponent,
                data: {
                    title: $localize`:@@subnavi.apps.trendviewer:Trendviewer`,
                    testId: 'sidenavigation.link.trendviewer',
                    favouritesTitle: '[ParentPageName]',
                    privileges: [
                        RoutePrivilegeNames.AppsTrendViewerUI
                    ]
                }
            },
            {
                path: 'DashboardEditor',
                component: DashboardEditorComponent,
                data: {
                    title: __asyncI18n('Dashboard Editor', 'subnavi.apps.dashboardeditor'),
                    testId: 'sidenavigation.link.dashboardeditor',
                    favouritesTitle: '[ParentPageName]',

                    privileges: [
                        RoutePrivilegeNames.AppsDashboardManage
                    ],
                    fullscreen: false
                }
            },
            {
                path: 'SystemDashboardEditor',
                component: SystemDashboarEditor,
                data: {
                    title: __asyncI18n('System Dashboard Editor', 'subnavi.apps.system.dashboardeditor'),
                    testId: 'sidenavigation.link.system-dashboardeditor',
                    favouritesTitle: '[ParentPageName]',
                    privileges: [
                        [
                            RoutePrivilegeNames.AppsSystemDashboardManage,
                            RoutePrivilegeNames.Systems
                        ],
                        [
                            RoutePrivilegeNames.AppsSystemDashboardManage,
                            RoutePrivilegeNames.SystemApplicationSets
                        ]
                    ],
                    fullscreen: false
                }
            },
            {
                path: 'BenchmarkDashboard',
                component: BenchmarkDashboardComponent,
                data: {
                    title: __asyncI18n('Benchmark Dashboard', 'subnavi.apps.benchmark-dashboard'),
                    testId: 'sidenavigation.link.benchmark-dashboard',
                    favouritesTitle: '[ParentPageName]',
                    fullscreen: false,
                    privileges: [
                        RoutePrivilegeNames.AppsBenchmarkDashboardUI
                    ]
                }
            },
            {
                path: 'CloudGraphicConfigurator',
                ///component: WebPictureEditorScreenComponent,
                loadChildren: () => import('modules/webpicture-editor-module/index').then(m => m.WebpictureEditorModule),
                data: {
                    title: __asyncI18n('Graphic configurator', 'subnavi.apps.webpictureeditor'),
                    testId: 'sidenavigation.link.webpictureeditor',
                    redirectTo: 'Apps/CloudGraphicConfigurator/Editor',
                    privileges: [
                        RoutePrivilegeNames.AppsWebGraphic
                    ],
                    fullscreen: false
                }
            },
          
            {
                path: 'ScriptingEditor',
                component: ScriptingEditorComponent,
                data: {
                    title: __asyncI18n('Scripting Editor', 'subnavi.apps.scriptingeditor'),
                    testId: 'sidenavigation.link.scriptingeditor',
                    favouritesTitle: '[ParentPageName]',

                    privileges: [
                        RoutePrivilegeNames.ScriptingRuntime
                    ],
                    fullscreen: false
                }
            },
            {
                path: 'GraphicBuilder',
                component: AppContainerPageComponent,
                data: {
                    title: __asyncI18n('Graphic Builder', 'subnavi.apps.graphicbuilder'),
                    testId: 'sidenavigation.link.graphicbuilder',
                    favouritesTitle: '[ParentPageName]',
                    appContainerConfig : {
                        name: 'GraphicBuilder',
                        source: '/Content/GraphicBuilder/app.html',
                        origin: '*',
                        sandboxPrivileges: [
                            SandboxPolicy['allow-downloads']
                        ]
                    }
                }
            },
            {
                path: 'AlarmDashboard',
                data: {
                    title: __asyncI18n('Alarm Dashboard', 'subnavi.apps.alarmdashboard'),
                    testId: 'sidenavigation.link.alarmdashboard',
                    privileges: [
                        [
                            RoutePrivilegeNames.AppsAlarmImportIds
                        ]
                        
                    ],
                    favouritesTitle: '[ParentParentPageName]',
                    showChildrenAsSecondLevel: true,
                    redirectTo: [
                        'Apps/AlarmDashboard/ImportAlarmIds'
                    ]
                },
                children : [
                    {
                        path: 'ImportAlarmIds',
                        component: ImportAlarmIdsComponent,
                        data: {
                            title: __asyncI18n('Import Alarm Ids', 'subnavi.apps.import-alarm-ids'),
                            testId: 'sidenavigation.link.importalarmids',
                            privileges: [
                                RoutePrivilegeNames.AppsAlarmImportIds
                            ],
                            favouritesTitle: '[ParentParentPageName]'
                        }
                    }
                ]
            },
            {
                path: 'RuleEngine',
                component: DummySiteComponent,
                data: {
                    title: __asyncI18n('Rule Editor', 'subnavi.apps.ruleengine'),
                    testId: 'sidenavigation.link.ruleengine',
                    privileges: [
                        RoutePrivilegeNames.AppsRuleEngine
                    ],
                    externalLink: '/RuleEngine/?tenantId=:tenantid',
                    favouritesTitle: '[ParentParentPageName]',
                    fullscreen: false
                }
            },
            {
                path: 'HorizonReports',
                component: DummySiteComponent,
                data: {
                    title: __asyncI18n('Reports', 'subnavi.apps.horizonreports'),
                    testId: 'sidenavigation.link.horizonreports',
                    privileges: [
                        RoutePrivilegeNames.AppsBIRT
                    ],
                    externalLink: '/HorizonReports/?tenantId=:tenantid',
                    favouritesTitle: '[ParentParentPageName]',
                    fullscreen: false
                }
            },
            {
                path: 'HealthCheck',
                component: DummySiteComponent,
                data: {
                    title: __asyncI18n('Health check', 'subnavi.apps.healthcheck'),
                    testId: 'sidenavigation.link.healthcheck',
                    privileges: [
                        RoutePrivilegeNames.AppsHealthCheck
                    ],
                    externalLink: '/HealthCheck/?tenantId=:tenantid',
                    favouritesTitle: '[ParentParentPageName]',
                    fullscreen: false
                }
            },
            {
                path: 'AppContainerEditor',
                data: {
                    title: __asyncI18n('App Container Editor', 'subnavi.apps.container-editor'),
                    testId: 'sidenavigation.link.container-editor',
                    favouritesTitle: '[ParentParentPageName]',
                    lazyRedirectTo: '/Apps/AppContainerEditor/*firstChild',
                    showChildrenAsSecondLevel: true,
                    privileges: [
                        RoutePrivilegeNames.AppsContainerEditorUI
                    ]
                },
                children: [
                    {
                        path: 'Editor',
                        component: AppContainerEditorComponent,
                        data: {
                            title: __asyncI18n('App Container Editor', 'subnavi.apps.container-editor'),
                            testId: 'sidenavigation.link.container-editor',
                            favouritesTitle: '[ParentParentPageName]',
                            privileges: [
                                RoutePrivilegeNames.AppsContainerEditorUI
                            ]
                        },
                    },
                    {
                        path: 'Documentation',
                        component: AppContainerDocumentationComponent,
                        data: {
                            title: __asyncI18n(
                                'Documentation',
                                'subnavi.apps.app-container.documentation'
                            ),
                            testId: 'sidenavigation.link.app-container.documentation',
                            favouritesTitle: '[ParentParentPageName]',
                            favouritesCaption: '[ParentPageName] / [PageName]',
                            privileges: [
                                RoutePrivilegeNames.AppsContainerEditorUI
                            ]
                        },
                    },
                    {
                        path: 'HostApiDocumentation',
                        component: FramePageComponent,
                        data: {
                            frameUrl: '/docs/host-api/index.html',
                            title: __asyncI18n(
                                'Host API Documentation',
                                'subnavi.apps.app-container.api-documentation'
                            ),
                            testId: 'sidenavigation.link.app-container.api-documentation',
                            favouritesTitle: '[ParentParentPageName]',
                            favouritesCaption: '[ParentPageName] / [PageName]',
                            privileges: [
                                RoutePrivilegeNames.AppsContainerEditorUI
                            ]
                        }
                    }
                ]
            },
            {
                path: 'ApiPortal',
                data: {
                    title: __asyncI18n('Api Portal', 'subnavi.apps.api-portal'),
                    testId: 'sidenavigation.link.apiportal',
                    lazyRedirectTo: '/Apps/ApiPortal/*firstChild',
                    showChildrenAsSecondLevel: true,
                    privileges: [
                        RoutePrivilegeNames.AppsApiPortal
                    ]
                },
                children: [{
                    path: 'Introduction',
                    component: ApiDocumentationComponent,
                    data: {
                        title: __asyncI18n(
                            'Introduction',
                            'subnavi.apps.apiportal.introduction'
                        ),
                        testId: 'sidenavigation.link.apiportal.introduction',
                        favouritesTitle: '[ParentParentPageName]',
                        favouritesCaption: '[ParentPageName] / [PageName]',
                        privileges: [
                            RoutePrivilegeNames.AppsApiPortal
                        ]
                    }
                }, {
                    path: 'ReleaseNotes',
                    component: ApiComingSoonComponent,
                    data: {
                        title: __asyncI18n(
                            'Release Notes',
                            'subnavi.apps.apiportal.releasenotes'
                        ),
                        testId: 'sidenavigation.link.apiportal.releasenotes',
                        favouritesTitle: '[ParentParentPageName]',
                        favouritesCaption: '[ParentPageName] / [PageName]',
                        privileges: [
                            RoutePrivilegeNames.AppsApiPortal
                        ]
                    }
                },
                {
                    path: 'Documentation',
                    component: ApiComponent,
                    data: {
                        title: __asyncI18n(
                            'Documentation',
                            'subnavi.apps.apiportal.documentation'
                        ),
                        testId: 'sidenavigation.link.apiportal.documentation',
                        favouritesTitle: '[ParentParentPageName]',
                        favouritesCaption: '[ParentPageName] / [PageName]',
                        privileges: [
                            RoutePrivilegeNames.AppsApiPortal
                        ]
                    },
                },
                {
                    path: 'Faq',
                    component: ApiFaqComponent,
                    data: {
                        title: __asyncI18n(
                            'FAQ',
                            'subnavi.apps.apiportal.faq'
                        ),
                        testId: 'sidenavigation.link.apiportal.faq',
                        favouritesTitle: '[ParentParentPageName]',
                        favouritesCaption: '[ParentPageName] / [PageName]',
                        privileges: [
                            RoutePrivilegeNames.AppsApiPortal
                        ]
                    },
                }]
            }
        ]
    },
    /* {
         path : 'CookieInfo',
         component: CookieInfoComponent,
         outlet : 'loggedout',
         data : {
             title : cookieNoticeTile,
             testId: 'mainnavigation.link.cookie-info',
             dontShowInMainNavigation : true,
             dontShowInSubNavigation : truet,
             iconClass: ''
         }
     },*/
    {
        path: 'AlarmDashboard',
        component: AlarmDashboardComponent,
        data: {
            title: __asyncI18n('Alarm Dashboard', 'mainnavi.alarm-dashboard'),
            testId: 'mainnavigation.link.alarm-dashboard',
            pageLayout: 'max-screen-layout',
            privileges: [
                RoutePrivilegeNames.IntelligentAlarmAppUI
            ],
            iconClass:'simpl-icon-alarm'
        }
    }, {
        path: 'NodeRed',
        component: NodeRedComponent,
        data: {
            title: __asyncI18n('Rule Editor', 'mainnavi.node-red'),
            testId: 'mainnavigation.link.node-red',
            pageLayout: 'max-screen-layout',
            privileges: [
                RoutePrivilegeNames.NodeRedAppUI
            ],
            iconClass:'simpl-icon-process-value'
        }
    },
    {
        path: 'CookieInfo',
        pathMatch: 'full',
        data: {
            title: cookieNoticeTile,
            dontShowInMainNavigation: true
        },
        children: [
            {
                path: '',
                component: CookieInfoOutsideComponent,
                outlet: 'internalreleasenotes',
                data: {
                    title: cookieNoticeTile,
                    dontShowInMainNavigation: true,
                    dontShowInSubNavigation: true
                }
            }
        ]
    },
    {
        path: 'CookieNotice',
        pathMatch: 'full',
        data: {
            title: cookieNoticeTile,
            dontShowInMainNavigation: true
        },
        children: [
            {
                path: '',
                component: CookieInfoComponent,
                data: {
                    title: cookieNoticeTile,
                    dontShowInMainNavigation: true,
                    dontShowInSubNavigation: true
                }
            }
        ]
    },
];
